import { sortItemsByPriority } from './sortItems'

export const MAX_DISPLAYED_ITEMS = 15

const OPTIMISTIC_ID_THRESHOLD = 1000000000000

const isOptimistic = ({ id }) => typeof id === 'number' && id > OPTIMISTIC_ID_THRESHOLD

export const selectDisplayedItems = ({
  featuredComments,
  featuredRatings,
  comments,
  ratings,
  currentUserId,
}) => {
  const optimisticComments = comments.filter(isOptimistic)
  const optimisticRatings = ratings.filter(isOptimistic)
  const visibleFeaturedRatings = optimisticRatings.length
    ? featuredRatings.filter(({ userId }) => userId !== currentUserId)
    : featuredRatings

  const items = [
    ...[...optimisticRatings, ...visibleFeaturedRatings].map(rating => ({ ...rating, itemType: 'rating' })),
    ...[...optimisticComments, ...featuredComments].map(comment => ({ ...comment, itemType: 'comment' })),
  ]

  return sortItemsByPriority(items).slice(0, MAX_DISPLAYED_ITEMS)
}

export default selectDisplayedItems
